/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Preview_Col_TaskInputs */

const da_forside_preview_col_task = /** @type {(inputs: Forside_Preview_Col_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgave`)
};

/** @type {(inputs: Forside_Preview_Col_TaskInputs) => LocalizedString} */
const en_forside_preview_col_task = da_forside_preview_col_task;

/**

* @param {Forside_Preview_Col_TaskInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_preview_col_task = /** @type {((inputs?: Forside_Preview_Col_TaskInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Preview_Col_TaskInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_preview_col_task(inputs)
	return /** @type {LocalizedString} */ ("Opgave")
});